/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Input, useEffect, useState } from "@";
import { useWatch } from "react-hook-form";
import { useCharity } from "@/shared/hooks/useCharity";
import { slugify } from "../../lib/slug";

interface Props {
  register: any;
  setValue: any;
  control: any;
  errors: any;
  show?: string | undefined;
}

export const GeneralSettingsSection = ({
  register,
  setValue,
  control,
  errors,
  show,
}: Props) => {
  const isDisabled = !!show;
  const name = (useWatch({ control, name: "name" }) as string) ?? "";
  const slug = (useWatch({ control, name: "slug" }) as string) ?? "";

  // Track whether the user has manually edited the slug; once they have,
  // stop auto-syncing it from the page name.
  const [slugEdited, setSlugEdited] = useState(false);

  useEffect(() => {
    if (slugEdited || isDisabled) return;
    const next = slugify(name);
    if (next !== slug) {
      setValue("slug", next, { shouldDirty: true, shouldValidate: true });
    }
  }, [name, slugEdited, isDisabled, setValue, slug]);

  const { charityStoreUrl } = useCharity();
  const previewBase = (charityStoreUrl ?? "").replace(/\/$/, "");

  const slugReg = register("slug");

  return (
    <Card title="الإعدادات العامة">
      <div className="grid gap-5 lg:grid-cols-2">
        <Input
          label="اسم الصفحة (داخلي)"
          placeholder="مثال: حملة رمضان 2026"
          disabled={isDisabled}
          input={register("name")}
          error={errors?.name}
        />

        <div>
          <Input
            label="الرابط (Slug)"
            placeholder="ramadan-2026"
            disabled={isDisabled}
            input={slugReg}
            change={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSlugEdited(true);
              slugReg.onChange(e);
            }}
            error={errors?.slug}
          />
          <p className="mt-1 flex items-center gap-1 truncate text-xs text-gray-500 dark:text-gray-400">
            <svg
              aria-hidden="true"
              viewBox="0 0 16 16"
              fill="none"
              className="h-3.5 w-3.5 shrink-0"
            >
              <circle
                cx="8"
                cy="8"
                r="7"
                fill="currentColor"
                fillOpacity="0.12"
              />
              <path
                d="M8 4.5v4M8 11.25v.01"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
            يجب أن يحتوي الرابط على أحرف وأرقام وشرطات فقط
          </p>
          {slug && previewBase && previewBase !== "#" && (
            <p
              dir="ltr"
              className="mt-1 truncate text-xs text-gray-500 dark:text-gray-400"
            >
              {previewBase}/lp/{slug}
            </p>
          )}
        </div>

        <Input
          star="no"
          label="عنوان SEO"
          style="lg:col-span-2"
          placeholder="عنوان يظهر في نتائج البحث"
          disabled={isDisabled}
          input={register("seoTitle")}
          error={errors?.seoTitle}
        />

        <Input
          style="lg:col-span-2"
          star="no"
          type="textarea"
          label="وصف SEO"
          rows={3}
          placeholder="وصف قصير يظهر في نتائج البحث"
          disabled={isDisabled}
          input={register("seoDescription")}
          error={errors?.seoDescription}
        />
      </div>
    </Card>
  );
};
